<template>
    <NuxtImg
        :src="blok.image.filename"
        :alt="blok.image.alt"
        :title="blok.image.title"
        provider="storyblok"
        format="webp"
        sizes="50vw sm:50vw md:50vw lg:50vw xl:1920px"
        class="simple-image"
        :class="imageClasses"
        :style="imageStyles"
        loading="lazy"
    ></NuxtImg>
</template>

<script lang="ts" setup>
import type { ICoreSimpleImage } from '@nuxt-monorepo/ui/types/components/CoreSimpleImage';
import { EHideOnType } from '@nuxt-monorepo/ui/types/enums/ComponentStyle';

const { blok } = defineProps<{ blok: ICoreSimpleImage }>();

const objectPosition = computed(() => {
    if (blok.imagePositionHorizontal && blok.imagePositionVertical) {
        return `${blok.imagePositionHorizontal}% ${blok.imagePositionVertical}%`;
    }
});

const imageStyles = computed(() => {
    const styles: Record<string, string | null> = {
        objectFit: blok.imageFit || null,
        objectPosition: objectPosition.value || null,
        width: blok.width && !blok.fullWidth ? `${blok.width}px` : null,
        height: blok.height && !blok.fullWidth ? `${blok.height}px` : null,
        borderWidth: blok.borderWidth ? `${blok.borderWidth}px` : null,
        borderColor: blok.borderWidth ? blok.borderColor?.color || null : null,
        borderRadius:
            blok.usePixelRadius && blok.roundedPx ? `${blok.roundedPx}px` : blok.rounded ? `${blok.rounded}%` : null,
        maxHeight: blok.fullWidth && blok.maxHeight ? `${blok.maxHeight}px` : null,
    };

    // Remove nulls for cleaner styles object
    Object.keys(styles).forEach((key) => {
        if (styles[key] === null) delete styles[key];
    });

    return styles;
});

const imageClasses = computed(() => {
    return {
        'w-full': blok.fullWidth,
        'mobile-only': blok.hideOn === EHideOnType.Desktop,
        'desktop-only': blok.hideOn === EHideOnType.Mobile,
    };
});
</script>

<style lang="postcss" scoped>
.simple-image {
    @apply h-auto;
    &.mobile-only {
        @apply md:hidden;
    }
    &.desktop-only {
        @apply hidden md:block;
    }
}
</style>
